import React from "react";

export function getContributorRoles(contributor) {
  if (Array.isArray(contributor?.contributor_role)) {
    return contributor.contributor_role.filter(Boolean);
  }
  if (contributor?.contributor_role) {
    return [contributor.contributor_role];
  }
  return [];
}

export function hasCompleteBankInfo(contributor) {
  return Boolean(
    contributor?.bank_account_number &&
      contributor?.bank_iban_number &&
      contributor?.bank_swift_number &&
      contributor?.bank_name
  );
}

const ROLE_TONE = {
  artist: "artist",
  composer: "composer",
  lyricist: "lyricist",
  producer: "producer",
  writer: "writer",
  performer: "performer",
  arranger: "arranger",
  mixer: "mixer",
  engineer: "engineer",
};

export function ContributorRoleBadge({ role }) {
  const key = String(role || "").toLowerCase();
  const tone = ROLE_TONE[key] || "default";
  return (
    <span className={`ctr-role ctr-role--${tone}`} title={role}>
      {role}
    </span>
  );
}

export function ContributorBankBadge({ complete }) {
  return (
    <span className={`ctr-bank ctr-bank--${complete ? "complete" : "incomplete"}`}>
      {complete ? "Bank complete" : "Bank incomplete"}
    </span>
  );
}

export function ContributorSplitBadge({ splitCount, assetCount }) {
  const hasSplits = splitCount > 0;
  return (
    <div className="ctr-splits">
      <span className={`ctr-splits__badge ctr-splits__badge--${hasSplits ? "yes" : "no"}`}>
        {hasSplits ? "Has splits" : "No splits"}
      </span>
      <span className="ctr-splits__meta">
        {assetCount} asset{assetCount === 1 ? "" : "s"} · {splitCount} split{splitCount === 1 ? "" : "s"}
      </span>
    </div>
  );
}

export function buildSplitStatsByContributor(productsData) {
  const statsMap = {};
  const rawProducts = productsData?.data;
  const products = Array.isArray(rawProducts)
    ? rawProducts
    : Array.isArray(rawProducts?.data)
      ? rawProducts.data
      : [];

  products.forEach((product) => {
    const assets = Array.isArray(product?.assets) ? product.assets : [];
    assets.forEach((asset) => {
      const contributorsInAsset = Array.isArray(asset?.contributors) ? asset.contributors : [];

      contributorsInAsset.forEach((contributor) => {
        const contributorId = Number(contributor?.id);
        if (!Number.isFinite(contributorId)) return;

        if (!statsMap[contributorId]) {
          statsMap[contributorId] = { assetIds: new Set(), splitCount: 0 };
        }

        statsMap[contributorId].assetIds.add(Number(asset?.id));
        const royalties = Array.isArray(contributor?.royalties) ? contributor.royalties : [];
        statsMap[contributorId].splitCount += royalties.filter(
          (royalty) => royalty?.percentage != null && royalty?.percentage !== ""
        ).length;
      });
    });
  });

  return statsMap;
}
